export default "__VITE_ASSET__DWy_YeDt__"